






















































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import WidgetBox from "@/components/widget-box/widget-box.vue";
import EnergyFlow from "@/components/energyflow.vue";
import Graph from "@/components/graph.vue";
import WeatherGraph from "@/components/weatherGraph.vue";
import WeatherService from "@/services/weather-service";
import config from "@/services/api-config";
import GeneralService from "@/services/general-service";
import Forecast from "@/components/forecast.vue";
import RockerSwitch from "vue-rocker-switch";
import Gauge from "@/components/gauge.vue";
import PVGraph from "@/components/pvgraphs.vue";
import WeatherDataGraph from "@/components/weatherDataGraph.vue";
import "vue-rocker-switch/dist/vue-rocker-switch.css";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "../styles/global.scss";
import moment from "moment";
import rightSidebar from "@/components/rightSidebar.vue";
import Milestones from "@/components/milestones.vue";

@Component({
  components: {
    "widget-box": WidgetBox,
    "energy-flow": EnergyFlow,
    "rocker-switch": RockerSwitch,
    forecast: Forecast,
    "weather-graph": WeatherGraph,
    "weather-data-graph": WeatherDataGraph,
    "pv-graph": PVGraph,
    gauge: Gauge,
    graph: Graph,
    swiperSlide,
    swiper,
    "right-sidebar": rightSidebar,
    Milestones,
  },
})
export default class Dashboard extends Vue {
  private weather = new WeatherService();
  private deviceId = "0";
  private plantData = JSON.parse(localStorage[config.currentPlant]);
  private dashboardData: any = [];
  private dashData: any = [];
  private inverterData: any = [];
  private isNetMetered: boolean = false;
  private recentData: any = [];
  private weatherDataOptions: any = [];
  private selectedWeatherData = 0;
  private cloudiness = 0;
  private temperature = 0;
  private noData = false;
  private icon = "";
  private showGraph = false;
  private today = new Date();
  private isModal = false;
  private services = new GeneralService();
  private selectedInverter = 0;
  private forecastData: any[] = [];
  private selecterKey = 0;
  private forecastDataDaily: any[] = [];
  private dataTimestamp = "";
  private dataTimestampLast:any = "";
  private showRawData = false;
  private graphKey = 0;
  private inverterGraphKey = 0;
  private todayGenerated = 0;
  private distinctInvertors: any = [];
  private viewTable = false;
  private sortedInverters: any = [];
  private sortedLifeInverters: any = [];
  private timeOn = 0;
  private timeOff = 0;
  private plantStatus = "Offline";
  private plantType = "Residential";
  private mapSource = "";
  private dataCount = 0;
  private dateOffset = 0;
  private inverterIds: any = [];
  private inverterDataGraph: any = [];
  private weather_state: any = "";
  private mapLocation = "";
  private energyFlowKey = 0;
  private loaded1 = false;
  private loaded2 = false;
  private currentValue = false;
  private imageIndex = 0;
  private plantWeatherData: any = [];
  plantID=0;
  inverterID=0;
  statusID=0;
  alarmList:any=[];
  inverterList:any=[];
  private plantInverterList:any=[];
  private customOptions = {
    startDate: moment().startOf("hour"),
    endDate: moment().startOf("hour").add(32, "hour"),
    maxDate: moment().startOf("day").add(1, "day"),
    singleDatePicker: true,
  };
  private dateSelected: Date = new Date();

  swiperOptionSlider = {
    slidesPerView: 3,
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true,
    },
    keyboard: {
      enabled: true,
    },
    freeMode: true,
    breakpoints: {
      1100: {
        slidesPerView: 1,
      },
      1300: {
        slidesPerView: 2,
      },
    },
  };

  private rightSidebarKey = 0;

  private inverters = [
    {
      serial_id: 1,
      description: "",
      inverter_id: "Loading",
      inverter_status: 1,
      inverter_description: '',
      lifetime_energy: "",
      inner_temp: "",
      power: "",
      energy_generated: "",
      p1ac: "",
      p2ac: "",
      p3ac: "",
      max_power: "",
      percentagepartner: "",
      p1a: "",
      p2a: "",
      p1c: "",
      p2c: "",
      p1p: "",
      p2p: "",
      alarms: [],
      lastUpdated: '',
      specific_energy:""
    },
  ];

  private fields = [
    {
      key: "inverterstatus",
      label: "Inverter",
      sortable: true,
    },
    {
      key: "power",
      label: "Power Generating",
    },

    {
      key: "lifetime_energy",
      label: "Lifetime Energy",
    },
    {
      key: "percentagepartner",
      label: "Percentage Share",
    },
  ];

  private fieldsInverter = [
    {
      key: "power",
      label: "Power Generating",
    },
    {
      key: "inner_temp",
      label: "Inner Temperature",
    },
    {
      key: "lifetime_energy",
    },
    {
      key: "p1a",
      label: "Thread 1 Current",
    },
    {
      key: "p2a",
      label: "Thread 2 Current",
    },
    {
      key: "p1c",
      label: "Thread 1 Voltage",
    },
    {
      key: "p2c",
      label: "Thread 2 Voltage",
    },
    {
      key: "p1p",
      label: "Thread 1 Power",
    },
    {
      key: "p2p",
      label: "Thread 2 Power",
    },
    {
      key: "max_power",
    },
  ];

  private gaugeKey = 0;

  formatNumber(num) {
    if (num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }

    return 0;
  }

  toggleBack() {
    localStorage.removeItem(config.widget);
    window.location.reload();
  }
  formatDate(value) {
    return moment.unix(value).format("DD-MM-YYYY");
  }
  fetchData() {
    var d = new Date();
    d.setDate(d.getDate() - 1);
    const todayMidnight = new Date(this.today).setHours(0, 0, 0, 0);
    const dMidnight = new Date(d).setHours(0, 0, 0, 0);

    this.services.getNetMetered(this.plantData).then((response) => {this.isNetMetered = response.data.is_net_metered});

    this.services
      .getDashboard(this.plantData)
      .then((data) => {
        this.dashData = data.data;
        this.loaded1 = true;
        if (this.dashData.planttype == 2) {
          this.plantType = "Commercial";
        } else if (this.dashData.plantType == 3) {
          this.plantType = "Utility";
        }
        let timeCurrent = new Date(this.dashData.lastupdatereceived * 1000);
        

        this.mapSource =
          "https://www.google.com/maps/embed/v1/view?key=AIzaSyCv6j0EXuvoIlGCqbVtx2YNroviwmUpCRo&zoom=16&center=" +
          this.dashData.plantlocationlat +
          "," +
          this.dashData.plantlocationlng;
        this.mapLocation =
          "https://www.google.com/maps/@" +
          this.dashData.plantlocationlat +
          "," +
          this.dashData.plantlocationlng +
          ",18z";
        let dayCurrent = timeCurrent.getDate();
        let monthCurrent = timeCurrent.getMonth() + 1;
        let yearCurrent = timeCurrent.getFullYear();
        let hourCurrent = timeCurrent.getHours();
        let minuteCurrent = timeCurrent.getMinutes();
        let timeCycle = "am";

        this.weather
          .forecastApi(
            this.dashData.plantlocationlat,
            this.dashData.plantlocationlng
          )
          .then((response) => {
            this.forecastData = response.data;
            this.forecastDataDaily = [];
            for (let i = 0; i < 40; i += 8) {
              this.forecastDataDaily.push(response.data.list[i]);
            }
          });
        
        this.services.getWeatherData(this.plantData,
        todayMidnight / 1000,
        Math.round(Date.now() / 1000)).then((response) => {
          this.plantWeatherData = response.data.weather_data;
          this.weatherDataOptions = [];
          if (this.plantWeatherData.length > 0){
            for (let i = 0; i < this.plantWeatherData.length; i++){
              this.weatherDataOptions.push({ value: i, text: moment(this.plantWeatherData[i].timestamp*1000).format("hh:mm:ss a") })
            }
          }
          this.selectedWeatherData = this.plantWeatherData.length - 1;
        });

        this.weather
          .weatherApi(
            this.dashData.plantlocationlat,
            this.dashData.plantlocationlng
          )
          .then((response) => {
            this.temperature = response.data.main.temp;
            this.cloudiness = response.data.clouds.all;
            this.weather_state = response.data.weather[0].description;
            this.icon =
              "https://openweathermap.org/img/wn/" +
              response.data.weather[0].icon +
              "@2x.png";
            this.$store.commit("changeCloudy", this.cloudiness);
            this.$store.commit("changeIcon", this.icon);
            let date1 = new Date(response.data.sys.sunrise * 1000);
            let date2 = new Date(response.data.sys.sunset * 1000);
            let date1hour =
              date1.getHours() < 10 ? "0" + date1.getHours() : date1.getHours();
            let date2hour =
              date2.getHours() < 10 ? "0" + date2.getHours() : date2.getHours();
            let date1minutes =
              date1.getMinutes() < 10
                ? "0" + date1.getMinutes()
                : date1.getMinutes();
            let date2minutes =
              date2.getMinutes() < 10
                ? "0" + date2.getMinutes()
                : date2.getMinutes();
            this.timeOn = date1hour + ":" + date1minutes;
            this.timeOff = date2hour + ":" + date2minutes;
            let rightNow = new Date();

            if (
              date1.getHours() <= rightNow.getHours() &&
              date2.getHours() >= rightNow.getHours()
            ) {
              if (date1.getHours() == rightNow.getHours()) {
                if (date1.getMinutes() > rightNow.getMinutes()) {
                  this.plantStatus = "Online";
                } else {
                  this.plantStatus = "Offline";
                }
              } else if (date2.getHours() == rightNow.getHours()) {
                if (date2.getMinutes() >= rightNow.getMinutes()) {
                  this.plantStatus = "Online";
                } else {
                  this.plantStatus = "Offline";
                }
              } else {
                this.plantStatus = "Online";
              }
            }
          });

        if (hourCurrent >= 12) {
          if (hourCurrent > 12) hourCurrent = hourCurrent - 12;
          timeCycle = "pm";
        }

        this.dataTimestamp =
          (dayCurrent > 9 ? dayCurrent : "0" + dayCurrent) +
          "/" +
          (monthCurrent > 9 ? monthCurrent : "0" + monthCurrent) +
          "/" +
          yearCurrent +
          " " +
          (hourCurrent > 9 ? hourCurrent : "0" + hourCurrent) +
          ":" +
          (minuteCurrent > 9 ? minuteCurrent : "0" + minuteCurrent) +
          "  " +
          timeCycle;

        if (!this.dashData || this.dashData == undefined) {
          this.noData = true;
        } else {
          this.noData = false;
        }

        this.gaugeKey++;
        this.energyFlowKey++;
      })
      .catch((e) => {
        this.noData = true;
      });

    this.services
      .getPlantData(
        this.plantData,
        todayMidnight / 1000,
        Math.round(Date.now() / 1000)
      )
      .then((data) => {
        this.loaded2 = true;
        this.dashboardData = data.data.plantdata;
        
        if (this.dashboardData.length > 0) {
          this.recentData = this.dashboardData[this.dashboardData.length - 1];
          this.todayGenerated =
            this.recentData.lifetimeenergy -
            this.dashboardData[0].lifetimeenergy;
        } else {
          this.todayGenerated = 0;
          this.recentData = {
            powergenerated: 0,
            temperature: 0.0,
            humidity: 0.0,
            powerused: 0.0,
            powersold: 0.0,
            lifetimeenergy: 0,
            batterycurrent: 0.0,
            batterystatus: 0.0,
            timestamp: 0,
            energygenerated: 0.0,
          };
        }
        this.energyFlowKey++;
        this.gaugeKey++;

        let invertorsSelected: any = [];
        let invertersIndex: any = [];
        this.inverterData = data.data.inverterdetails;
        
        this.inverters = [];
        this.inverterIds = [];
        
        for (let i = 0; i < this.inverterData.length; i++) {
          this.inverterIds.push(this.inverterData[i].inverterSerialID);
          this.inverterDataGraph.push([]);
          console.log(JSON.stringify(this.dataTimestampLast))

          this.inverters.push({
            serial_id: i + 1,
            description: this.inverterData[i].description,
            inverter_id: this.inverterData[i].inverterSerialID,
            lifetime_energy: this.inverterData[i].lifetimeenergy + " kWh",
            inverter_status: this.inverterData[i].status,
            inverter_description: this.inverterData[i].status_description,
            inner_temp: this.inverterData[i].temperature + " Celsius",
            power: this.inverterData[i].powergenerated + " W",
            energy_generated: this.inverterData[i].energygenerated,
            p1a: this.inverterData[i].p1Amp,
            p2a: this.inverterData[i].p2Amp,
            p1p: this.inverterData[i].p1power,
            p2p: this.inverterData[i].p2power,
            p1c: this.inverterData[i].p1Current,
            p2c: this.inverterData[i].p2Current,
            max_power: this.inverterData[i].maxPower + " kVA",
            percentagepartner: this.inverterData[i].percentagepartner,
            alarms: this.inverterData[i].alarms,
            // lastUpdated: (this.dashboardData.length > 0 ? this.dashboardData[this.dashboardData.length-1].timestamp:this.dashData.lastupdatereceived),
            lastUpdated: this.inverterData[i].last_inverter_update,
            
            specific_energy:this.inverterData[i].specific_energy
            });
        }
        this.sortedInverters = Array.from(this.inverters);
        this.sortedLifeInverters = Array.from(this.inverters);
        
        this.sortedInverters.sort(function (a, b) {
          var keyA = parseInt(a.power),
            keyB = parseInt(b.power);
          // Compare the 2 dates
          if (keyA < keyB) return 1;
          if (keyA > keyB) return -1;
          return 0;
        });
        
        this.sortedLifeInverters.sort(function (a, b) {
          var keyA = parseInt(a.lifetime_energy),
            keyB = parseInt(b.lifetime_energy);
          // Compare the 2 dates
          if (keyA < keyB) return 1;
          if (keyA > keyB) return -1;
          return 0;
        });

        this.rightSidebarKey++;
        this.getPVGraph(todayMidnight / 1000, Math.round(Date.now() / 1000));
      });
  }

  getPVGraph(t1, t2) {
    this.inverterDataGraph = [];
    for (let i = 0; i < this.inverterData.length; i++) {
      this.inverterDataGraph.push([]);
    }
    this.services.getPVGraph(this.inverterIds, t1, t2).then((response) => {
      this.dataCount = 0;
      for (let i = 0; i < response.data.length; i++) {
        this.dataCount++;
        let _idx = this.inverterIds.indexOf(response.data[i].inverterserialid);
        this.inverterDataGraph[_idx].push(response.data[i]);
      }
      this.inverterGraphKey++;
    });
  }

  dateBack() {
    this.dateOffset--;
    var d = new Date(Date.now() + this.dateOffset * 864e5);
    const dMidnight = new Date(d).setHours(0, 0, 0, 0);
    const dEnd = new Date(d).setHours(23, 59, 59, 0);
    this.getPVGraph(dMidnight / 1000, dEnd / 1000);
    this.customOptions.startDate = moment()
      .startOf("hour")
      .add(this.dateOffset, "day");
    this.selecterKey++;
  }

  dateForward() {
    this.dateOffset++;
    var d = new Date(Date.now() + this.dateOffset * 864e5);
    const dMidnight = new Date(d).setHours(0, 0, 0, 0);
    const dEnd = new Date(d).setHours(23, 59, 59, 0);
    this.getPVGraph(dMidnight / 1000, dEnd / 1000);
    this.customOptions.startDate = moment()
      .startOf("hour")
      .add(this.dateOffset, "day");
    this.selecterKey++;
  }

  customData() {
    let start = moment(this.dateSelected, "DD-MM-YYYY");
    let end = moment(this.dateSelected, "DD-MM-YYYY").add(1, "day");
    this.getPVGraph(
      start.toDate().getTime() / 1000,
      end.toDate().getTime() / 1000
    );
  }

  mounted() {
    this.plantID=this.plantData;
    this.GetPlantsAndInvertersList();
    this.loadAlarmList();
    if (!this.plantData || this.plantData === undefined) {
      this.$router.push("/");
    }
    this.$nextTick(function () {
      window.addEventListener("resize", () => {
        this.gaugeKey++;
      });
    });
    this.services.getDeviceId(this.plantData).then((response) => {
      this.deviceId = response.data.name;
    });

    this.fetchData();

    if (
      localStorage[config.widget] == undefined ||
      !localStorage[config.widget]
    ) {
      const widgets = [
        { name: "profile", status: true },
        { name: "perfomance", status: true },
        { name: "timings", status: true },
        { name: "inverter", status: true },
        { name: "savings", status: true },
        { name: "elec-generated", status: true },
        { name: "envir", status: true },
        { name: "energyflow", status: true },
        { name: "current-power", status: true },
        { name: "energygraph", status: true },
        { name: "weather", status: true },
      ];

      localStorage[config.widget] = JSON.stringify(widgets);
    } else {
      const widgets = JSON.parse(localStorage[config.widget]);
      for (let widget of widgets) {
        const element = document.getElementById(widget.name);
        if (element && !widget.status) {
          element.style.display = "none";
        }
      }
    }

    setInterval(() => {
      this.fetchData();
    }, 600000);
  }

  carouselSelected(id) {
    for (let i = 0; i < this.inverters.length; i++) {
      if (this.inverters[i].inverter_id == id) {
        this.selectedInverter = i;
        break;
      }
    }

    let _idx;
    for (let i = 0; i < this.inverterData.length; i++) {
      if (this.inverterData[i].inverterSerialID == id) {
        _idx = i;
        break;
      }
    }
    (this.$refs["inverter-modal"] as any).show();
    setTimeout(() => {
      let data = JSON.parse(this.inverterData[_idx].rawjsondataforinverter);
      data.holdingregisters = JSON.parse(data.holdingregisters);
      data.inputregisters = JSON.parse(data.inputregisters);
      let container = document.getElementById("container");
      if (container) {
        container.appendChild(renderjson(data));
      }
    }, 1000);
  }

  rowSelected(item: any, idx: any) {
    // alert(JSON.stringify(item))
    for (let i = 0; i < this.inverters.length; i++) {
      if (this.inverters[i].inverter_id == item.inverter_id) {
        this.selectedInverter = i;
        break;
      }
    }

    let _idx;
    for (let i = 0; i < this.inverterData.length; i++) {
      if (this.inverterData[i].inverterSerialID == item.inverter_id) {
        _idx = i;
        break;
      }
    }
    (this.$refs["inverter-modal"] as any).show();
    setTimeout(() => {
      let data = JSON.parse(this.inverterData[_idx].rawjsondataforinverter);
      data.holdingregisters = JSON.parse(data.holdingregisters);
      data.inputregisters = JSON.parse(data.inputregisters);
      let container = document.getElementById("container");
      if (container) {
        container.appendChild(renderjson(data));
      }
    }, 1000);
  }

  handleBackPanel() {
    this.$router.push("/");
  }

  showPicture() {
    this.$bvModal.show("plant-picture");
    this.imageIndex = 0;
  }

  nextImage() {
    console.log(this.imageIndex);
    if (this.imageIndex < this.dashData.images_list.length - 1) {
      this.imageIndex++;
    } else {
      this.imageIndex = 0;
    }
  }

  prevImage() {
    if (this.imageIndex !== 0) {
      this.imageIndex--;
    } else {
      this.imageIndex = this.dashData.images_list.length - 1;
    }
  }

  handleAnalysis() {
    this.$router.push("/analysis");
  }

  GetPlantsAndInvertersList(){
    this.services.GetPlantsAndInvertersList().then((response)=>{
      if(response.data){
      this.plantInverterList=response.data.response.filter(event => event.SerialID==this.plantID);
      this.loadInverters();
      }

    })
  }

  loadInverters(){
    let a=this.plantInverterList.filter(event => event.SerialID==this.plantID);
    if(a.length>0){
    this.inverterList=a[0].plantinverters;

    }
  }

  loadAlarmList(){
    this.services.Getallalarmsclient(this.plantID,this.inverterID,this.statusID).then((response)=>{
      if(response.data.total_records>0){
        this.alarmList=response.data.alarms_list;
      }
      else{
        this.alarmList=[];
      }
    })
  }
  markAlarmResolved(id) {
    this.$confirm("Are you sure to change the status?").then(() => {
      this.services.updateAlarmStatus(id).then((response) => {
        this.loadAlarmList();
      });
    });
  }
}
